// extracted by mini-css-extract-plugin
export default {"title":"Header_title__jl7mg","astros":"Header_astros__XRFb9","container":"Header_container__-RLkY"};